<template>
  <div>

    <InputGroup :show-errors="true"
                validation-id="name"
                v-model="object.name"
                @change="onChange('name')"
                :label="$t('title')"
                :required="true">
      <SimilarMaterialFound :material="foundDuplicates.name"/>
    </InputGroup>

    <InputGroup :show-errors="true"
                validation-id="barcode"
                v-model="object.barcode"
                @change="onChange('barcode')"
                :label="$t('barcode')"
                :required="false">
      <SimilarMaterialFound :material="foundDuplicates.barcode"/>
    </InputGroup>

    <InputGroup :show-errors="true"
                validation-id="artikul"
                v-model="object.artikul"
                @change="onChange('artikul')"
                :label="$t('artikul')"
                :required="false">
      <SimilarMaterialFound :material="foundDuplicates.artikul"/>
    </InputGroup>

  </div>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup.vue"
import { EloquentService } from "@/services/api/eloquent.api.service"
import {reactive} from "vue"
import SimilarMaterialFound from "@/components/parts/warehouse/SimilarMaterialFound.vue"

const props = defineProps({
  object: {
    type: Object
  },
})

const foundDuplicates = reactive({
  name: null,
  barcode: null,
  artikul: null
})

const onChange = async (property) => {
  if(!props.object[property]) {
    foundDuplicates[property] = null
    return
  }
  try {
    const res = await EloquentService.dataTable('material', 1, {
      pagination: 2,
      sort: 'desc',
      order: 'id',
      condition: { [property]: props.object[property] }
    }, false)
    const results = (res.data?.result?.data || []).filter(x => !props.object.material_id || x.material_id !== props.object.material_id)
    foundDuplicates[property] = results.length > 0 ? results[0] : null
  } catch (e) {
    foundDuplicates[property] = null
    console.log(e)
  }
}
</script>
